// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"pa_a bib_qt bib_a bib_w","FaqAskQuestion__outdated":"pa_b bib_vr bib_xg"};